import StoreCountry from '@Stores/StoreCountry'
import { lowerCase } from 'lodash'
import ReactGA from 'react-ga'
import { makeAutoObservable } from 'mobx'
class TrackingEvents {

    get trackingPages() {
        return [
            'menu',
            'commission',
            'orderhistory',
            'seminars',
            'bmi',
            'marketing-artwork',
            'digital-member-card',
            'settings',
            'genealogy/table',
            'genealogy/dashboard',
            'genealogy/card',
            'genealogy/level',
            'shopping',
            'catproduct/all',
            'feedback',
            'cart',
            'checkout',
            'ordersummary',
            'checkout/summary',
            'checkout/payment-response/success',
            'checkout/payment-response/failed',
            'reports',
            'something-went-wrong'
        ]
    }

    CommitToGoogleAnalytic(label, category, action, fullCountryName, interAction) {

        console.log('Tracking event label:', label)

        let GACode = StoreCountry.GACode2021[lowerCase(fullCountryName)]
        let GACodeAll = 'UA-188539463-1'

        const eachMarket = lowerCase(fullCountryName)
        const allMarketName = 'Ushop'
        const trackers = [
            {
                trackingId: GACodeAll,
                gaOptions: { name: allMarketName },
                debug: false
            },
            {
                trackingId: GACode,
                gaOptions: { name: eachMarket },
                debug: false
            }
        ]
        ReactGA.initialize(trackers)
        ReactGA.pageview(label, [allMarketName, eachMarket])
        ReactGA.event({
            category: category,
            action: action,
            label: label,
            nonInteraction: interAction,
        }, [allMarketName, eachMarket])

    } 

    // Ecommerce
    CommitECAction(action, actionType, payload) {

        ReactGA.plugin.execute('ec', action, actionType, payload)
        ReactGA.plugin.execute('ec', 'send');

    }
    // Ecommerce Clear
    EcommerceClear(page) {
        ReactGA.pageview(page)
        ReactGA.plugin.execute('ec', 'clear');

    }

 

    Commit(fullCountryName) {
        let GACode = StoreCountry.GACode2021[lowerCase(fullCountryName)]
        let GACodeAll = 'UA-188539463-1'

        const eachMarket = lowerCase(fullCountryName)
        const allMarketName = 'Ushop'
        const trackers = [
            {
                trackingId: GACodeAll,
                gaOptions: { name: allMarketName }
            },
            {
                trackingId: GACode,
                gaOptions: { name: eachMarket }
            }
        ] 
        ReactGA.initialize(trackers)
        ReactGA.plugin.require('ec', { path: '/log', debug: false });
        ReactGA.pageview(window.location.pathname, [allMarketName, eachMarket])
    }

    get CATEGORY() {
        return {
            PAGE_VIEW: 'Page View',
            EXTERNAL_LINK: 'External Link',
        }
    }

    get ACTION() {
        return {
            CLICK: 'click',
            VIEW: 'view',
            MOBILE_CLICK: 'click via mobile',
            MOBILE_VIEW: 'view on mobile',
            SETACTION: 'setAction'
        }
    }
    get ACTION_TYPE() {
        return {
            ADD_PRODUCT: 'addProduct',
            REMOVE_PRODUCT: 'removeProduct',
            CHECKOUT: 'checkout',
            CLEAR_CART: 'clearcart'
        }
    }

    get EVENT_TYPE() {

        return {
            ADD_ITEM: 'ADD_ITEM',
            REMOVE_ITEM: 'REMOVE_ITEM',
            PURCHASE: 'PURCHASE',
            CLEAR_CART: 'CLEAR_CART'
        }
    }

    constructor() {

        makeAutoObservable(this)
    }
}

export default new TrackingEvents()